import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentDeletionFailedAction = {
	type: 'DOCUMENT_DELETION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentDeletionFailedAction => ({
	type: 'DOCUMENT_DELETION_FAILED',
	payload,
});
